export default __webpack_public_path__ + "static/share-image-4f1bddba84d9be8dab587f8152bd79c5.png";